module.exports = __webpack_public_path__ + "a57b3b60c2a62f62033d33b1d11ec9a5.png";